import _createClass from "/builds/hydrogen-appz/marketing-ui/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/builds/hydrogen-appz/marketing-ui/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _inherits from "/builds/hydrogen-appz/marketing-ui/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/builds/hydrogen-appz/marketing-ui/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/builds/hydrogen-appz/marketing-ui/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _wrapNativeSuper from "/builds/hydrogen-appz/marketing-ui/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper.js";
import _toConsumableArray from "/builds/hydrogen-appz/marketing-ui/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var createSprinkles = function createSprinkles(composeStyles) {
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var sprinklesStyles = Object.assign.apply(Object, [{}].concat(_toConsumableArray(args.map(function (a) {
      return a.styles;
    }))));
    var sprinklesKeys = Object.keys(sprinklesStyles);
    var shorthandNames = sprinklesKeys.filter(function (property) {
      return 'mappings' in sprinklesStyles[property];
    });

    var sprinklesFn = function sprinklesFn(props) {
      var classNames = [];
      var shorthands = {};

      var nonShorthands = _objectSpread2({}, props);

      var hasShorthands = false;

      var _iterator = _createForOfIteratorHelper(shorthandNames),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var shorthand = _step.value;
          var value = props[shorthand];

          if (value != null) {
            var sprinkle = sprinklesStyles[shorthand];
            hasShorthands = true;

            var _iterator3 = _createForOfIteratorHelper(sprinkle.mappings),
                _step3;

            try {
              for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                var propMapping = _step3.value;
                shorthands[propMapping] = value;

                if (nonShorthands[propMapping] == null) {
                  delete nonShorthands[propMapping];
                }
              }
            } catch (err) {
              _iterator3.e(err);
            } finally {
              _iterator3.f();
            }
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      var finalProps = hasShorthands ? _objectSpread2(_objectSpread2({}, shorthands), nonShorthands) : props;

      for (var prop in finalProps) {
        var propValue = finalProps[prop];
        var _sprinkle = sprinklesStyles[prop];

        try {
          if (_sprinkle.mappings) {
            // Skip shorthands
            continue;
          }

          if (typeof propValue === 'string' || typeof propValue === 'number') {
            if (process.env.NODE_ENV !== 'production') {
              if (!_sprinkle.values[propValue].defaultClass) {
                throw new Error();
              }
            }

            classNames.push(_sprinkle.values[propValue].defaultClass);
          } else if (Array.isArray(propValue)) {
            for (var responsiveIndex = 0; responsiveIndex < propValue.length; responsiveIndex++) {
              var responsiveValue = propValue[responsiveIndex];

              if (responsiveValue != null) {
                var conditionName = _sprinkle.responsiveArray[responsiveIndex];

                if (process.env.NODE_ENV !== 'production') {
                  if (!_sprinkle.values[responsiveValue].conditions[conditionName]) {
                    throw new Error();
                  }
                }

                classNames.push(_sprinkle.values[responsiveValue].conditions[conditionName]);
              }
            }
          } else {
            for (var _conditionName in propValue) {
              // Conditional style
              var _value = propValue[_conditionName];

              if (_value != null) {
                if (process.env.NODE_ENV !== 'production') {
                  if (!_sprinkle.values[_value].conditions[_conditionName]) {
                    throw new Error();
                  }
                }

                classNames.push(_sprinkle.values[_value].conditions[_conditionName]);
              }
            }
          }
        } catch (e) {
          if (process.env.NODE_ENV !== 'production') {
            (function () {
              var SprinklesError = /*#__PURE__*/function (_Error) {
                _inherits(SprinklesError, _Error);

                var _super = _createSuper(SprinklesError);

                function SprinklesError(message) {
                  var _this;

                  _classCallCheck(this, SprinklesError);

                  _this = _super.call(this, message);
                  _this.name = 'SprinklesError';
                  return _this;
                }

                return _createClass(SprinklesError);
              }( /*#__PURE__*/_wrapNativeSuper(Error));

              var format = function format(v) {
                return typeof v === 'string' ? "\"".concat(v, "\"") : v;
              };

              var invalidPropValue = function invalidPropValue(prop, value, possibleValues) {
                throw new SprinklesError("\"".concat(prop, "\" has no value ").concat(format(value), ". Possible values are ").concat(Object.keys(possibleValues).map(format).join(', ')));
              };

              if (!_sprinkle) {
                throw new SprinklesError("\"".concat(prop, "\" is not a valid sprinkle"));
              }

              if (typeof propValue === 'string' || typeof propValue === 'number') {
                if (!(propValue in _sprinkle.values)) {
                  invalidPropValue(prop, propValue, _sprinkle.values);
                }

                if (!_sprinkle.values[propValue].defaultClass) {
                  throw new SprinklesError("\"".concat(prop, "\" has no default condition. You must specify which conditions to target explicitly. Possible options are ").concat(Object.keys(_sprinkle.values[propValue].conditions).map(format).join(', ')));
                }
              }

              if (typeof propValue === 'object') {
                if (!('conditions' in _sprinkle.values[Object.keys(_sprinkle.values)[0]])) {
                  throw new SprinklesError("\"".concat(prop, "\" is not a conditional property"));
                }

                if (Array.isArray(propValue)) {
                  if (!('responsiveArray' in _sprinkle)) {
                    throw new SprinklesError("\"".concat(prop, "\" does not support responsive arrays"));
                  }

                  var breakpointCount = _sprinkle.responsiveArray.length;

                  if (breakpointCount < propValue.length) {
                    throw new SprinklesError("\"".concat(prop, "\" only supports up to ").concat(breakpointCount, " breakpoints. You passed ").concat(propValue.length));
                  }

                  var _iterator2 = _createForOfIteratorHelper(propValue),
                      _step2;

                  try {
                    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                      var _responsiveValue = _step2.value;

                      if (!_sprinkle.values[_responsiveValue]) {
                        invalidPropValue(prop, _responsiveValue, _sprinkle.values);
                      }
                    }
                  } catch (err) {
                    _iterator2.e(err);
                  } finally {
                    _iterator2.f();
                  }
                } else {
                  for (var _conditionName2 in propValue) {
                    var _value2 = propValue[_conditionName2];

                    if (_value2 != null) {
                      if (!_sprinkle.values[_value2]) {
                        invalidPropValue(prop, _value2, _sprinkle.values);
                      }

                      if (!_sprinkle.values[_value2].conditions[_conditionName2]) {
                        throw new SprinklesError("\"".concat(prop, "\" has no condition named ").concat(format(_conditionName2), ". Possible values are ").concat(Object.keys(_sprinkle.values[_value2].conditions).map(format).join(', ')));
                      }
                    }
                  }
                }
              }
            })();
          }

          throw e;
        }
      }

      return composeStyles(classNames.join(' '));
    };

    return Object.assign(sprinklesFn, {
      properties: new Set(sprinklesKeys)
    });
  };
};

export { createSprinkles as c };